import React, {FC} from 'react';
import classNames from 'classnames';
import {LocationIcon, SuitcaseIcon} from 'components';
import {LazyImage, useBreakpoint} from 'hooks';

import {TProfessionalHeadshot} from '../utils';

import {TextLabel} from './DirectBookingLabel';

type Props = {
  name: string;
  licences: string[];
  states?: string[];
  slim?: boolean;
  headshot: TProfessionalHeadshot;
};

const DirectBookingProviderHeader: FC<Props> = ({
  headshot,
  name,
  licences,
  states,
  slim,
}: Props) => {
  const {isXs} = useBreakpoint('xs');

  return (
    <div
      className={classNames('flex xs:flex-row xs:justify-start relative', {
        'items-center flex-col': !slim,
        'items-start pb-4': slim,
      })}
    >
      <LazyImage
        src={headshot.medium}
        srcSet={`${headshot.medium} ${headshot.large}3x`}
        alt="Professional Headshot"
        lqip={headshot.small}
        type="image/png"
        aspectRatio={1}
        className={classNames(
          'rounded-full -mt-[6px] border-[6px] box-content border-[#ffcb58]/[.15] object-cover',
          {
            'min-w-[148px] min-h-[148px] mb-7': !slim,
            'min-w-[120px] min-h-[120px]': slim,
          },
        )}
      ></LazyImage>
      <div
        className={classNames('flex flex-col xs:ml-4', {
          'items-center': !slim && !isXs,
          'items-start': slim || isXs,
        })}
      >
        <span
          className={classNames('font-montserrat leading-6 font-medium ml-2', {
            'text-3xl mb-2': !slim,
            'text-xl': slim,
          })}
        >
          {name}
        </span>
        {states?.length ? (
          <span className="text-gray-600 -m-1 -ml-3">
            <TextLabel
              text={states.join(', ')}
              border={false}
              icon={
                <LocationIcon
                  height={21}
                  strokeColor="text-blue-600"
                  classes="flex-shrink-0 self-center"
                  width={21}
                />
              }
            />
          </span>
        ) : null}
        {licences?.length ? (
          <TextLabel
            text={licences.join(', ')}
            selected={true}
            icon={
              <SuitcaseIcon height={18} classes="flex-shrink-0 self-center" />
            }
          />
        ) : null}
      </div>
    </div>
  );
};

export default DirectBookingProviderHeader;
